import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { ManualSearch } from '@app/store';

/**
 * When user searches for a keyword.
 */
const events = getEvents((action: ManualSearch) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'searchManual',
      keyword: action.payload.query
    }
  }
]);

export default events;
